import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import selectExpensesTotal from '../selectors/expenses-total';
import selectExpenses from '../selectors/expenses';
import numeral from 'numeral';


export const ExpenseSummary = ({ count, total }) => {
  const totalExpenses = numeral(total / 100).format('$0,0.00');
  const expenseLabel = count === 1 ? ' expense ' : ' expenses '
  return (
    <div className="page-header">
      <div className="content-container">

        <h1 className="page-header__title">Viewing <span>{count}</span>{expenseLabel}Totalling: <span>{totalExpenses}</span></h1>
        <div className="page-header__actions">
          <Link className="button" to="/create">Add Expense</Link>
        </div>

      </div>

    </div>
  )
};

const mapStateToProps = (state) => {
  const viewableExpenses = selectExpenses(state.expenses, state.filters)

  return {

    count: viewableExpenses.length,
    total: selectExpensesTotal(viewableExpenses)



  };
};

export default connect(mapStateToProps)(ExpenseSummary);



// WEBPACK FOOTER //
// ./src/components/ExpenseSummary.js